exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".subtitle{font-size:1.3rem;font-weight:700;margin-bottom:16px}.box-card{text-align:left}.box-card .title{font-size:1.5rem;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2295796b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/userprotocol.vue
// module id = 144
// module chunks = 0